export default {"src":"/_next/static/media/nh-shape.0a48c8c9.svg","height":331,"width":291};